/**
 * Token Store - Memory-Only Storage (Top-Tier Security)
 * 
 * WHY NOT LOCALSTORAGE?
 * - localStorage is vulnerable to XSS attacks
 * - Any malicious script can steal tokens from localStorage
 * - Top companies (Google, GitHub, Stripe) use httpOnly cookies
 * 
 * SECURITY APPROACH:
 * - Access Token: In-memory only (lost on refresh, that's OK)
 * - Refresh Token: httpOnly cookie (handled by backend, unreachable by JS)
 * - On refresh: Use refresh token cookie to get new access token
 * 
 * This prevents XSS token theft while maintaining session persistence!
 */

let currentAccessToken: string | null = null;

export const E2E_ACCESS_TOKEN_SESSION_KEY = '__qumashi_e2e_access_token__';

function readE2eAccessTokenFromSession(): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    return sessionStorage.getItem(E2E_ACCESS_TOKEN_SESSION_KEY);
  } catch {
    return null;
  }
}

export const tokenStore = {
  getAccessToken(): string | null {
    if (!currentAccessToken) {
      const e2eToken = readE2eAccessTokenFromSession();
      if (e2eToken) currentAccessToken = e2eToken;
    }
    return currentAccessToken;
  },
  setAccessToken(token: string | null) {
    currentAccessToken = token;
    // NEVER store in localStorage - that's a security risk!
  },
  clear() {
    currentAccessToken = null;
  },
};


